"use client";

import NextError from "next/error";
import { useEffect } from "react";
import { monitoring } from "@/services/monitoring";
import { handleIfServerActionVersionSkew } from "@/utils/serverActions/versionSkew";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // A server action invalidated by a new deployment can bubble up here. Reload
    // to the latest build rather than logging it as an exception and showing the
    // generic error page.
    if (handleIfServerActionVersionSkew(error, { component: "GlobalError" })) {
      return;
    }
    monitoring.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}